import React, { Component, useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { loader } from 'graphql.macro';
import { Drawer, Space, Alert, message, Row, Col } from 'antd';
import { rules, FormField, FormComponent } from 'Common/components/Form'
import { Button } from 'Common/components';
import { __error } from 'Common/scripts/consoleHelper'
import { withApollo } from '@apollo/client/react/hoc';
import { updateModule } from '../InternalStore/actions'
import { connect } from 'react-redux'
import { getmodulePermissions } from 'Common/scripts/Security';
const modulePermissions = getmodulePermissions('course-mg');

const ADD_MODULE = loader('src/Graphql/Courses/addCourseModule.graphql');
const EDIT_MODULE = loader('src/Graphql/Courses/editCourseModule.graphql');

const ModuleForm = ({ onSubmit, fields, busy }) => {
    return(<>
        <FormComponent onSubmit={onSubmit} id={`CourseModuleForm`} debug={false} loading={busy}
            fields={{ ...fields }}
            mutators={{
                updateBody: (newValueArray, state, tools) => {
                    let node = newValueArray[0];
                    tools.changeValue(state, 'body', () => node);
                },
            }}
            form_render={formProps => {
                const { values, form, invalid, dirty, valid, pristine, submitting } = formProps;

                return (<>
                    <FormField label="Module Title" name="title" type="text" compact validate={rules.required} />
                    <FormField label="Body Text" name="title" type="html" compact validate={rules.required} onUpdate={form.mutators.updateBody}
                        data={(values && values.body) ? values.body : null}
                        editorStyle={{ minHeight: "calc(100vh - 210px)" }}
                        // toolbar={{ options: ['inline', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'image', 'remove', 'history',] }}
                    />
                    {/* <Button type="primary" size="medium" htmlType='submit' disabled={!dirty || !valid} >Save</Button> */}
                </>)

            }}
        />

    </>)
}

const ModuleFormWrapper = ({ formData, showForm, editNode, client, onClose, r_updateModule }) => {
    // const [showForm, setShowForm] = useState(false)
    console.log("ModuleFormWrapper: ", { showForm, editNode })
    const [busy, setBusy] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        // if (isEditing) setShowForm(true);
          return () => {
              setBusy(false)
              setError(null)
          };
    }, [showForm])

    const onSubmit = (values) => {
        setError(null);

        const input = {
            course_id: formData._id,
            title: values.title,
            body: values.body
        }

        if (editNode && editNode._id) {
            Object.assign(input, { _id: editNode._id });
            updateRecord(input);
        } else {
            addRecord(input);
        }

    }

    const addRecord = (input) => {
        if (!modulePermissions['course-mg.add']) return;

        setBusy(true);

        client.mutate({ mutation: ADD_MODULE, variables: { input } }).then(r => {
            let response = r.data.addCourseModule;

            if (response.error) {
                setBusy(false);
                // setError(response.error.message);
                message.error(response.error.message)
                return;
            }
            message.success("Module Added!");
            r_updateModule(response)
            onClose()

        }).catch(err => {
            console.log("ERROR: ", JSON.stringify(err, 0, 2));
            message.error("Failed to process the request!");
            setError("Failed to process the request!")
            setBusy(false);
        })

    }

    const updateRecord = (input) => {
        if (!modulePermissions['course-mg.edit']) return;

        setBusy(true);

        client.mutate({ mutation: EDIT_MODULE, variables: { input } }).then(r => {
            let response = r.data.editCourseModule;

            if (response.error) {
                setBusy(false);
                setError(response.error.message);
                return;
            }
            message.success("Saved!");
            r_updateModule(response)
            onClose()

        }).catch(err => {
            console.log("ERROR: ", JSON.stringify(err, 0, 2));
            message.error("Failed to process the request!");
            setBusy(false);
        })
    }


    return (<>
        <Drawer
            height={"100%"} placement="top" onClose={onClose} visible={showForm}
            title={editNode ? "Update Module" : "Create New Module"}
            // bodyStyle={{ paddingBottom: 80 }}
            // extra={<Button onClick={() => toggleModule()}>Cancel</Button>}
            footer={<Row>
                {/* <Col flex="auto"><Button type="button" onClick={form.reset} disabled={submitting || pristine}>Reset</Button></Col> */}
                <Col>
                    <Button loading={busy} disabled={false} type="primary" onClick={() => {
                        document.getElementById(`CourseModuleForm`).dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
                    }}>Save Module</Button>
                </Col>
            </Row>}
            destroyOnClose={true}
        ><>
            {error && <Alert message="Error" description={error} type="error" showIcon />}
                {!formData._id && <Alert message="Error" description="Course ID not found!" type="error" showIcon />}

                {showForm && <ModuleForm busy={busy} onSubmit={onSubmit} fields={{ ...editNode }} />}
        </></Drawer>
    </>)
}
ModuleFormWrapper.propTypes = {
    editNode: PropTypes.object,
    showForm: PropTypes.bool,
    // course_id: PropTypes.oneOfType([
    //     PropTypes.number,
    //     PropTypes.string,
    // ]),
    onClose: PropTypes.func,
}


const mapStateToProps = ({ formData }) => {
    return { formData };
};
const mapDispatchToProps = dispatch => ({
    r_updateModule: (payload) => dispatch(updateModule(payload)),
});
const Wrapper = connect(mapStateToProps, mapDispatchToProps)(ModuleFormWrapper)

export default withApollo(Wrapper)